export default {"src":"/_next/static/media/email_nudge_cross.74c32799.svg","height":25,"width":29,"blurWidth":0,"blurHeight":0};